import { useWeb3Context } from '../context/web3Provider';

export const useWallets = () => {
  const { wallets } = useWeb3Context();
  return wallets;
};
